module.exports = __webpack_public_path__ + "img/reset_failed.5bd27a6f.svg";